import PropTypes from 'prop-types';
import { MediaQuery, Spinner, Colors } from '@spotahome/ui-library';
import {
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  CartesianGrid,
  AreaChart as RechartsAreaChart,
  Area
} from 'recharts';

import './styles.scss';
import ChartTooltip from '../ChartTooltip/ChartTooltip';

const { isMobileScreen, isPhabletScreen, isTabletScreen } = MediaQuery;

const MIN_PRICE_RATIO = 0.75;

const mobileBarSize = 15;
const desktopBarSize = 45;
const chartHeight = 300;
const chartMinWidth = 380;

const defaultValueFormatter = value => value;

const AreaChart = ({
  loading = false,
  data,
  valueFormatter = defaultValueFormatter
}) => {
  const isMobileOrTablet = () =>
    isMobileScreen() || isPhabletScreen() || isTabletScreen();

  const barSize = isMobileOrTablet() ? mobileBarSize : desktopBarSize;

  if (loading) {
    return (
      <ResponsiveContainer
        width="100%"
        height={chartHeight}
        className="chart-spinner"
      >
        <Spinner />
      </ResponsiveContainer>
    );
  }

  const maxPrice = Math.ceil(
    Math.max(...data.map(item => item.averagePrice), 0)
  );

  const minPrice =
    Math.floor(Math.min(...data.map(item => item.averagePrice), Infinity)) *
    MIN_PRICE_RATIO;

  return (
    <div className="area-chart__container">
      <ResponsiveContainer
        width="100%"
        height={chartHeight}
        minWidth={chartMinWidth}
      >
        <RechartsAreaChart data={data} barGap={4} barSize={barSize}>
          <CartesianGrid strokeDasharray="4 0" stroke={Colors['ultra-light']} />
          <XAxis
            dataKey="label"
            tickLine={false}
            fill={Colors.medium}
            fontSize={12}
            tickMargin={10}
          />
          <YAxis
            domain={[minPrice, maxPrice]}
            tickLine={false}
            fontSize={12}
            fill={Colors.medium}
            tickFormatter={valueFormatter}
          />
          <Tooltip
            cursor={{ fill: 'transparent' }}
            content={<ChartTooltip valueFormatter={valueFormatter} />}
          />
          <Area
            dataKey="averagePrice"
            stroke={Colors['ultra-light']}
            fillOpacity={1}
            fill={Colors.interaction}
          />
        </RechartsAreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AreaChart;

AreaChart.propTypes = {
  loading: PropTypes.bool,
  valueFormatter: PropTypes.func,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      averagePrice: PropTypes.number
    })
  ).isRequired
};
